/**
 * MW STUFFS - Variant Pills
 * Handles variant selection, URL update, price update, and dispatches events
 * for cart drawer / sticky ATC / bundle blocks to listen to.
 */
(function () {
  if (customElements.get('variant-pills')) return;

  class VariantPills extends HTMLElement {
    constructor() {
      super();
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.productUrl = this.dataset.url;
      this.sectionId = this.dataset.section;
      this.inputs = this.querySelectorAll('input[type="radio"]');
      this.inputs.forEach((input) => {
        input.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    onVariantChange() {
      const selectedOptions = this.getSelectedOptions();
      const variant = this.variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      this.updateSelectedLabels();

      if (!variant) {
        this.toggleSubmitButton(true, 'Unavailable');
        this.dispatchEvent(new CustomEvent('variant:unavailable', { bubbles: true }));
        return;
      }

      this.updateUrl(variant);
      this.updateMasterId(variant);
      this.updatePrice(variant);
      this.updateMedia(variant);
      this.toggleSubmitButton(!variant.available, variant.available ? null : 'Sold Out');

      // Custom event for sticky ATC, bundle block, cart drawer
      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant, sectionId: this.sectionId },
        })
      );
    }

    getSelectedOptions() {
      const selected = [];
      this.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        const fieldset = input.closest('.mw-pill-group');
        const idx = parseInt(fieldset.dataset.optionIndex, 10);
        selected[idx] = input.value;
      });
      return selected;
    }

    updateSelectedLabels() {
      this.querySelectorAll('.mw-pill-group').forEach((group) => {
        const checked = group.querySelector('input:checked');
        const label = group.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
      });
    }

    updateUrl(variant) {
      if (!variant) return;
      window.history.replaceState({}, '', `${this.productUrl}?variant=${variant.id}`);
    }

    updateMasterId(variant) {
      const idInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
      if (idInput) idInput.value = variant.id;
    }

    updatePrice(variant) {
      const priceContainer = document.querySelector(`[data-price-container="${this.sectionId}"]`);
      if (!priceContainer) return;
      // Refresh theme uses Shopify's section rendering API for live price
      fetch(`${this.productUrl}?variant=${variant.id}&section_id=${this.sectionId}`)
        .then((r) => r.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newPrice = parsed.querySelector(`[data-price-container="${this.sectionId}"]`);
          if (newPrice) priceContainer.innerHTML = newPrice.innerHTML;
        })
        .catch(() => {});
    }

    updateMedia(variant) {
      if (!variant.featured_media) return;
      const event = new CustomEvent('variant:media', {
        bubbles: true,
        detail: { mediaId: variant.featured_media.id },
      });
      this.dispatchEvent(event);
    }

    toggleSubmitButton(disable, text) {
      const btn = document.querySelector(`#product-form-${this.sectionId} [name="add"]`);
      if (!btn) return;
      btn.disabled = disable;
      const span = btn.querySelector('span');
      if (text && span) {
        btn.dataset.originalText = btn.dataset.originalText || span.textContent;
        span.textContent = text;
      } else if (!disable && span && btn.dataset.originalText) {
        span.textContent = btn.dataset.originalText;
      }
    }
  }

  customElements.define('variant-pills', VariantPills);
})();
